import Footer from "./Footer";
import Header from "./Header";
import { Outlet } from "react-router-dom";
import React from "react";

function Layout(props) {
  return (
    <>
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

export default Layout;
